// extracted by mini-css-extract-plugin
export default {"wrapper":"MainLayout_wrapper__tCcHm","content":"MainLayout_content__yOcZV"};